'use strict';

const STORAGE_KEY = 'rmt-features';

function parseFeatureString(value) {
  if (!value) return [];
  return value.split(',').map((s) => s.trim()).filter(Boolean);
}

function listFromUrl() {
  const params = new URLSearchParams(globalThis.location?.search ?? '');
  const values = [];
  if (params.has('features')) {
    values.push(...parseFeatureString(params.get('features')));
  }
  if (params.has('feature')) {
    values.push(...parseFeatureString(params.get('feature')));
  }
  return values.length > 0 ? values : null;
}

function listFromStorage() {
  const raw = globalThis.localStorage?.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Return the active feature flags. URL `?features=a,b` wins over localStorage
 * and is persisted to localStorage for the current session.
 */
export function listEnabled() {
  const fromUrl = listFromUrl();
  if (fromUrl !== null) {
    globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify(fromUrl));
    return fromUrl;
  }
  return listFromStorage();
}

/**
 * Check whether a single feature flag is enabled. The magic flag `all`
 * enables every feature.
 */
export function isEnabled(flag) {
  const list = listEnabled();
  return list.includes(flag) || list.includes('all');
}

/**
 * Persist a feature flag in localStorage for the current session.
 */
export function enable(flag) {
  const list = new Set(listEnabled());
  list.add(flag);
  globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify([...list]));
}

/**
 * Remove a feature flag from localStorage.
 */
export function disable(flag) {
  const list = new Set(listEnabled());
  list.delete(flag);
  globalThis.localStorage?.setItem(STORAGE_KEY, JSON.stringify([...list]));
}

/**
 * Clear all stored feature flags.
 */
export function clearAll() {
  globalThis.localStorage?.removeItem(STORAGE_KEY);
}
